import { ChainId } from '@pancakeswap/sdk'
import FarmsBscPriceHelper from './56'
import FarmsBscTestnetPriceHelper from './97'
import FarmsKasplexTestnetPriceHelper from './167012'
import FarmsIgraTestnetPriceHelper from './19416'
import FarmsKasplexMainnetPriceHelper from './202555'
import FarmsEthereumPriceHelper from './1'
import FarmsGoerliPriceHelper from './5'

export const getFarmsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.BSC:
      return FarmsBscPriceHelper
    case ChainId.BSC_TESTNET:
      return FarmsBscTestnetPriceHelper
    case ChainId.KASPLEX_TESTNET:
      return FarmsKasplexTestnetPriceHelper
    case ChainId.IGRA:
      return FarmsIgraTestnetPriceHelper
    case ChainId.KASPLEX_MAINNET:
      return FarmsKasplexMainnetPriceHelper
    case ChainId.ETHEREUM:
      return FarmsEthereumPriceHelper
    case ChainId.GOERLI:
      return FarmsGoerliPriceHelper
    default:
      return []
  }
}
